import {translate} from "../../../translate/translate";
import {Box, Grid, Typography} from "@mui/material";
import * as React from "react";
import logo from "../../../../assets/images/logo-nrecontrol.svg";

const HomeComponent = () => {
    return (
        <>
            <div className="bg-home">
                <div className="floating-title title-home">
                    <Typography variant={"h5"}>
                        {translate.t("welcome_home") + " NRE Control"}
                    </Typography>
                </div>
                <div>
                    <Grid
                        container
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                        className="grid-container">
                        <Grid >
                            <Typography style={{paddingBottom: "8px"}} variant={"h5"}>{translate.t("welcome_home")}</Typography>
                        </Grid>
                        <Grid >
                            <Box component={"img"} sx={{height: 60}} alt="Logo NRE Control" src={logo}/>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </>
    );
};

export default HomeComponent;
